import {
  C_VIDEO_CARD_INLINE_CLASSNAME,
  C_VIDEO_CARD_INLINE_SLIM_CLASSNAME,
} from '../../components/4-organisms/playlist-carousel-inline/costants';

import widget from './widget';

export default {
  ...widget,
  cardsToSlide: 1,
  cardWidth: {
    [C_VIDEO_CARD_INLINE_CLASSNAME]: {
      mobile: 298,
      desktop: 298,
    },
    [C_VIDEO_CARD_INLINE_SLIM_CLASSNAME]: {
      mobile: 302,
      desktop: 302,
    },
  },
};
